"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _main = require("../main");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var deleteIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));

var errorIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}));

var FileItem = function FileItem(_ref) {
  var _ref$fileName = _ref.fileName,
      fileName = _ref$fileName === void 0 ? "" : _ref$fileName,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? "" : _ref$error,
      singleFileMode = _ref.singleFileMode,
      showPreview = _ref.showPreview,
      preview = _ref.preview,
      type = _ref.type,
      onDelete = _ref.onDelete,
      tabIndex = _ref.tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var getIconAriaLabel = function getIconAriaLabel() {
    if (type.includes("video")) return "video";else if (type.includes("audio")) return "audio";else return "file";
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.fileInput
  }, /*#__PURE__*/_react["default"].createElement(MainContainer, {
    error: error,
    singleFileMode: singleFileMode,
    showPreview: showPreview
  }, showPreview && (type.includes("image") ? /*#__PURE__*/_react["default"].createElement(ImagePreview, {
    src: preview,
    alt: fileName
  }) : /*#__PURE__*/_react["default"].createElement(IconPreview, {
    error: error,
    "aria-label": getIconAriaLabel()
  }, preview)), /*#__PURE__*/_react["default"].createElement(FileItemContent, null, /*#__PURE__*/_react["default"].createElement(FileName, null, fileName), /*#__PURE__*/_react["default"].createElement(_main.DxcFlex, {
    gap: "0.25rem"
  }, error && /*#__PURE__*/_react["default"].createElement(ErrorIcon, null, errorIcon), /*#__PURE__*/_react["default"].createElement(DeleteFileAction, {
    onClick: function onClick() {
      onDelete(fileName);
    },
    title: translatedLabels.fileInput.deleteFileActionTitle,
    "aria-label": translatedLabels.fileInput.deleteFileActionTitle,
    tabIndex: tabIndex
  }, deleteIcon)), error && !singleFileMode && /*#__PURE__*/_react["default"].createElement(ErrorMessage, null, error))));
};

var MainContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  width: ", ";\n  padding: ", ";\n  ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-radius: ", ";\n"])), function (props) {
  return props.singleFileMode ? "230px" : "320px";
}, function (props) {
  return props.showPreview ? "calc(8px - ".concat(props.theme.fileItemBorderThickness, ")") : "calc(8px - ".concat(props.theme.fileItemBorderThickness, ") calc(8px - ").concat(props.theme.fileItemBorderThickness, ") calc(8px - ").concat(props.theme.fileItemBorderThickness, ") 16px");
}, function (props) {
  return props.error ? "background-color: ".concat(props.theme.errorFileItemBackgroundColor, ";") : "";
}, function (props) {
  return props.error ? props.theme.errorFileItemBorderColor : props.theme.fileItemBorderColor;
}, function (props) {
  return props.theme.fileItemBorderThickness;
}, function (props) {
  return props.theme.fileItemBorderStyle;
}, function (props) {
  return props.theme.fileItemBorderRadius;
});

var ImagePreview = _styledComponents["default"].img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 48px;\n  height: 48px;\n  border-radius: 2px;\n  object-fit: contain;\n"])));

var IconPreview = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  width: 48px;\n  height: 48px;\n  padding: 15px;\n  border-radius: 2px;\n  color: ", ";\n\n  svg {\n    height: 18px;\n    width: 18px;\n  }\n"])), function (props) {
  return props.error ? props.theme.errorFilePreviewBackgroundColor : props.theme.filePreviewBackgroundColor;
}, function (props) {
  return props.error ? props.theme.errorFilePreviewIconColor : props.theme.filePreviewIconColor;
});

var FileItemContent = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-grow: 1;\n  display: grid;\n  grid-template-columns: auto min-content;\n  grid-template-rows: min-content auto;\n  column-gap: 0.25rem;\n"])));

var FileName = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  align-self: center;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (props) {
  return props.theme.fileNameFontColor;
}, function (props) {
  return props.theme.fileItemFontFamily;
}, function (props) {
  return props.theme.fileItemFontSize;
}, function (props) {
  return props.theme.fileItemFontWeight;
}, function (props) {
  return props.theme.fileItemLineHeight;
});

var ErrorIcon = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  padding: 3px;\n  height: 18px;\n  width: 18px;\n  color: #d0011b;\n"])));

var DeleteFileAction = _styledComponents["default"].button(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 24px;\n  width: 24px;\n  font-size: 1rem;\n  font-family: ", ";\n  border: 1px solid transparent;\n  border-radius: 2px;\n  background-color: transparent;\n  box-shadow: 0 0 0 2px transparent;\n  padding: 3px;\n  cursor: pointer;\n  color: ", ";\n\n  svg {\n    line-height: 18px;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus,\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.deleteFileItemColor;
}, function (props) {
  return props.theme.hoverDeleteFileItemBackgroundColor;
}, function (props) {
  return props.theme.focusDeleteFileItemBorderColor;
}, function (props) {
  return props.theme.activeDeleteFileItemBackgroundColor;
});

var ErrorMessage = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props.theme.errorMessageFontColor;
}, function (props) {
  return props.theme.errorMessageFontFamily;
}, function (props) {
  return props.theme.errorMessageFontSize;
}, function (props) {
  return props.theme.errorMessageFontWeight;
}, function (props) {
  return props.theme.errorMessageLineHeight;
});

var _default = /*#__PURE__*/_react["default"].memo(FileItem);

exports["default"] = _default;